<template>
  <menu-tab
    :menu="menu"
    :slidesPerView="menu.length"
    :initIndex="Number(postType)"
    @change="selectMenu"
  ></menu-tab>
  <div class="post-topic">
    <ui-form
      v-model:title="title"
      v-model:content="content"
      v-model:file="files"
    ></ui-form>
    <div class="reward" v-if="currentMenuItem == menu[1]">
      <ui-checkbox
        label="悬赏100积分"
        size="large"
        v-model="publicReward"
        @onChange="changeReward"
      ></ui-checkbox>
    </div>
    <div class="button">
      <ui-button type="submit" @click="submit">发布</ui-button>
    </div>
  </div>
  <!-- <div class="menu-nav-second" v-show="currentMenuItem == menu[1]">
    <p class="contribute_title">《行业新闻》、《技术前沿》版块投稿须知</p>
    <div class="hot_so">投稿方式：</div>
    <p class="contribute_email">
      邮箱投稿，来稿请投至伟业计量邮箱<span
        style="color: #df0024; font-weight: 600"
        >news@bzwz.com</span
      >
    </p>
    <p class="contribute_email">
      联系人：罗志单，手机号：132 1388 0178(同微信)
    </p>
    <div class="hot_so">文稿要求：</div>
    <p class="contribute_email">
      （1）文稿为计量领域，如食品检测、药物分析、环境监测、实验室管理方法与建设、图谱解析、仪器检测分析等。
    </p>
    <p class="contribute_email">
      （2）来稿应有较高的学术水平、创新性和实用性。内容实事求是，论点鲜明，数据可靠，层次清楚，文字精练。
    </p>
    <p class="contribute_email">（3）如有插图，图片要清晰。</p>
    <p class="contribute_email">
      （4）来稿时应写清作者姓名、单位、邮编、通讯地址及联系电话。
    </p>
    <div class="hot_so">稿费说明：</div>
    <p class="contribute_email">（1）每篇文稿可获80元基础稿费。</p>
    <p class="contribute_email">（2）阅读量300以上的，每百个增加20%稿费。</p>
    <p class="contribute_email">（3）本次活动不限参与人数，不限投稿篇数。</p>
    <p class="contribute_email">（4）当月投稿，次月底公布结果并结算稿费。</p>
    <div class="hot_so">注意事项：</div>
    <p class="contribute_email">
      （1）作者向我方所投之稿件，须尚未在任何媒体上发表，同时作者必须对所提供稿件的真实性负责；另外作者向我方投稿时不得同时向别处投稿。
    </p>
    <p class="contribute_email">
      （2）请作者自留底稿，投出后三天后内无答复的，稿件可另行处理，未刊用稿件恕不退稿。
    </p>
    <p class="contribute_email">
      （3）文章如发生知识产权争议，责任由作者自负；本刊有权对来稿作文字性修改、删节。
    </p>
    <p class="contribute_email">（4）最终解释权归伟业计量所有。</p>
  </div> -->
  <loading :options="loadOption" v-if="loading"></loading>
</template>
<script lang="ts">
import MenuTab from "@/components/common/MenuTab.vue";
import UiForm from "@/components/common/Form.vue";
import UiButton from "@/components/UI/Button";
import UiCheckbox from "@/components/UI/Checkbox";
import axios from "@/api/axios";
import Toast from "@/components/UI/Toast";
import { defineComponent, ref, inject, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import qs from "qs";
import Loading from "@/components/UI/Loading/src/Loading.vue";

export default defineComponent({
  name: "PostTopic",
  components: { MenuTab, UiForm, UiButton, UiCheckbox, Loading },
  setup() {
    //  切换列表菜单
    const route = useRoute();
    const type = route.query.type || void 0;
    type Menu = "帖子" | "问答";
    const menu: Menu[] = type ? ["帖子"] : ["帖子", "问答"];
    const router = useRouter();
    const currentMenuItem = ref(menu[0]);
    let postType = route.query.postType || 0;

    if (route.query.postType) {
      currentMenuItem.value = menu[Number(postType)];
      console.log(currentMenuItem.value);
    }
    const publicReward = ref(false);
    function changeReward(event: boolean) {
      publicReward.value = event;
    }

    function selectMenu(item: Menu) {
      currentMenuItem.value = item;
      switch (item) {
        case "帖子":
          postType = 0;
          break;
        case "问答":
          postType = 1;
          break;
      }
      router.push({
        name: "PostTopic",
        query: {
          postType,
        },
      });
    }
    const title = ref("");
    const content = ref("");
    const files = ref([]);
    let topicId = "";
    if (type) {
      topicId = route.query.id as string;
      axios
        .get("/M/Discover/EditPostTopics/" + topicId, {
          params: { validate: true },
        })
        .then((res) => {
          if (res.data.success) {
            const data = res.data.obj.entity;
            title.value = data.title;

            // let contentData = data.content;
            let contentData = res.data.obj.topicDetail.topicContent
            contentData = contentData.replace(/[(<p> | </p> )]/g, "");
            contentData = contentData.replace(/[</p><p>]/g, "\n");
            content.value = contentData;

            const list = data.picLinks
              ? data.picLinks.split(",")
              : data.videos
              ? data.videos.split(",")
              : [];
            list.forEach((item: string) => {
              (files.value as any).push({
                src: item,
              });
            });
          } else {
            Toast({
              type: "error",
              title: res.data.msg,
            });
          }
        })
        .catch((e) => {
          Toast({
            type: "error",
            title: e.message || e,
          });
        });
    }

    const imageReg = /image\/(.+)/;
    const videoReg = /video\/(.+)/;
    const loading = ref(false);
    const loadOption = {
      text: "正在上传...",
      color: "#df0024",
      textColor: "#df0024",
    };
    function upload(uploadFiles: any[]) {
      return new Promise((resolve, reject) => {
        const fileEmpty = uploadFiles.length === 0;
        let url = "";

        let pics = "",
          videos = "",
          isImg = false,
          isVideo = false;
        let file = null;
        const map4Reg = /\.mp4/g;
        uploadFiles.forEach((item) => {
          if (item.file) {
            file = item.file;
          } else {
            if (map4Reg.test((item as any).src)) {
              videos = item.src;
            } else {
              pics = pics + (item.src ? item.src + "," : "");
            }
          }
        });
        if (fileEmpty || !file) {
          resolve({ pics, videos });
        }

        if (file && imageReg.test((file as any).type)) {
          url = "/M/FroalaApi/UploadImage";
          isImg = true;
        }
        if (file && videoReg.test((file as any).type)) {
          url = "/M/FroalaApi/UploadVideo";
          isVideo = true;
        }

        const formData = new FormData();
        uploadFiles.forEach((item) => {
          formData.append("file", item.file);
        });
        if(url){
          try {
            axios
                    .post(url, formData, {
                      timeout: 0,
                    })
                    .then((res) => {
                      if (res.data.success) {
                        if (isImg) {
                          pics = pics + res.data.returnUrl;
                        }
                        if (isVideo) {
                          videos = res.data.returnUrl;
                        }
                        resolve({ pics, videos });
                      }
                    });
          } catch (e) {
            Toast({
              type: "error",
              title: Object.prototype.toString.call(e),
            });
          }
        }
      });
    }

    const userInfo = inject("userInfo") as any;
    const destoryKeepAlive = inject(
      "destoryKeepAlive"
    ) as () => Promise<unknown>;
    function submit() {
      const credit = 0;
      const _url = !type
        ? "/M/BBSServer/MDoPostTopic?rnd="
        : "/M/BBSServer/DoEditTopic?rnd=";
      const kid = 1;
      const formType = postType ? 3 : undefined;
      const score = publicReward.value ? 100 : 0;
      if (title.value == "") {
        Toast({
          title: "请输入标题！",
          type: "warning",
        });
        return false;
      }
      if (content.value == "") {
        Toast({
          title: "请输入帖子内容！",
          type: "warning",
        });
        return false;
      }
      loading.value = true;
      upload(files.value).then((res: any) => {
        const data = !type
          ? qs.stringify({
              kid,
              title: title.value,
              content: content.value,
              credit,
              type: formType,
              score,
              ...res,
            })
          : qs.stringify({
              id: topicId,
              title: title.value,
              content: content.value,
              type: formType,
              score,
              ...res,
            });
        axios
          .post(_url, data)
          .then((res) => {
            if (res.data.success) {
              loading.value = false;
              Toast({
                type: "success",
                title: res.data.msg,
                onClose: () => {
                  destoryKeepAlive().then(() => {
                    router.back();
                  });
                },
              });
            } else {
              Toast({
                type: "error",
                title: res.data.msg,
              });
            }
          })
          .catch((err) => {
            loading.value = false;
            console.log("err");
          });
      });
    }

    watch(
      () => {
        return route.query;
      },
      (to, from) => {
        currentMenuItem.value = menu[Number(to.postType)];
      }
    );

    return {
      menu,
      currentMenuItem,
      selectMenu,
      title,
      content,
      files,
      submit,
      loading,
      loadOption,
      changeReward,
      publicReward,
      postType,
    };
  },
});
</script>

<style lang="scss" scoped>
.button {
  width: 355px;
  margin: 0 auto;
  margin-top: 30px;
}

.hot_so {
  font-size: 0.4rem;
  padding: 0.133rem;
  font-weight: bold;
}

.post_btn {
  margin-top: 0.4rem;
}

.contribute_title {
  font-size: 0.44rem;
  font-weight: 600;
  width: 100%;
  margin: 0 auto;
  text-align: center;
}

.contribute_email {
  padding-left: 0.267rem;
  font-size: 0.4rem;
}

.menu-nav-second {
  width: 355px;
  padding: 30px 0;
  box-sizing: border-box;
  margin: 0 auto;
  color: #666;
}

.fr-box.fr-basic .fr-element {
  padding: 0.267rem;
}

.fr-box.fr-basic .fr-wrapper {
  background-color: #f6f6f6;
}

.fr-box.fr-basic .fr-wrapper,
.fr-box.fr-basic.fr-top .fr-wrapper {
  border: none;
}

.second-toolbar {
  display: none;
}

.reward {
  display: flex;
  justify-content: flex-start;
  width: 355px;
  margin: 20px auto;

  .reward-input {
    // width: 20%;
    // border: 1px solid #ccc;
    border: none;
    color: #ffffff;
    background-color: #ffffff;
  }
}
</style>
